import { render, staticRenderFns } from "./ContentLeft.vue?vue&type=template&id=2d88e802&scoped=true"
import script from "./ContentLeft.vue?vue&type=script&lang=js"
export * from "./ContentLeft.vue?vue&type=script&lang=js"
import style0 from "./ContentLeft.vue?vue&type=style&index=0&id=2d88e802&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d88e802",
  null
  
)

export default component.exports